import Image from './Image';

function extractFirstURL(str, extesion = '.jpg') {
  const regex = /https:\/\/[^\s]+/;
  const match = str.match(regex);
  if (match && match.length > 0) {
    const firstIndex = match[0].indexOf(extesion);
    if (firstIndex >= 0)
      return match[0].substring(0, firstIndex + extesion.length);
  }
  return null;
}

class AccommodationType {
  id!: string;
  name!: string;
  packageId?: string;
  images: Image[] = [];

  constructor(data: undefined | any = {}) {
    this.id = data.room_type_id.toString();
    this.name = data.title;
    this.packageId = data.package_id || '0';
    const pictureURL = extractFirstURL(data.room_type_photos);
    if (pictureURL) {
      this.images.push(new Image(pictureURL));
    }
  }
}

export default class AccommodationTypeList {
  items!: AccommodationType[];

  constructor(data: undefined | any = {}) {
    // in this part `accomodation_types` is spelled with one `m`, that comes from the API
    const { accomodation_types = [] } = data;
    this.items = accomodation_types.map((room) => new AccommodationType(room));
  }
}
